import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment.prod';
import { Router } from '@angular/router';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(appRef => {
    const router = appRef.injector.get(Router);
    router.events.subscribe(event => console.log(event)); // Logs router events
  })
  .catch(err => console.error(err));
